import { VREditor } from './editor';
import { Button, FieldLabel } from 'ca-ui';
export class VRSaveToolsPanel {
  constructor (vr, editor, toolbar) {
    this.vr = vr;
    this.editor = editor;
    this.toolbar = toolbar;

    this.saveToolsPanel = $('<div class="ca-vr_editortoolbar-save"></div>');
    this.toolbar.append(this.saveToolsPanel);
    this.initControls();
  }

  initControls () {
    // add save as draft button
    this.saveTimeStatus = new FieldLabel({ label: '' });
    this.saveToolsPanel.append(this.saveTimeStatus.el);
    this.saveAsDraftButton = new Button({ label: 'Save as draft' });
    this.saveAsDraftButton.on(
      'click',
      function () {
        this.editor.save(VREditor.PublishStatus.DRAFT);
      }.bind(this)
    );
    this.saveToolsPanel.append(this.saveAsDraftButton.el);

    this.saveAndPublishButton = new Button({ label: 'Save and publish' });
    this.saveAndPublishButton.on(
      'click',
      function () {
        this.editor.save(VREditor.PublishStatus.PUBLISHED);
      }.bind(this)
    );
    this.saveToolsPanel.append(this.saveAndPublishButton.el);
  }
}
